/* eslint-disable no-console */
<template>
<div  class="mb-r">
    <mdb-row  class="mb-r">
        <mdb-col md="12">
          <mdb-col col="12"
            class="bg-dark white-text p-3"
          >
            <mdb-row>
              <mdb-col col="11">
                <label>Grupo</label>
              </mdb-col>
              <mdb-col col="1">
                <i class="fas fa-times float-right" @click.prevent="closeDialog()"></i>
              </mdb-col>
            </mdb-row>
            <mdb-row>
              <mdb-col md="6">
                <select class="form-control" v-model="searchGroup" @change="loadData()">
                  <option selected disabled>-- Seleccionar grupo --</option>
                  <option
                    v-for="group in totalGroups"
                    :key="group.group"
                    v-bind:value="group.group"
                  >
                  Group  {{ group.group }}
                  </option>
                </select>
              </mdb-col>
              <mdb-col md="3"></mdb-col>
              <mdb-col md="3">
                <button class="btn btn-outline-white btn-block btn-sm mt-1"  @click.prevent="downLoadCSV()">
                  Download CSV
                </button>
              </mdb-col>
            </mdb-row>
          </mdb-col>

          <mdb-col col="12" class="bg-light-grey px-3 py-2">
            <div><strong>Teacher:</strong> {{ selectedGroup.teacher_name }}</div>
            <div>
              <strong>Marks instructions: </strong>
              <span>
                <i class="far fa-square ml-2"> T:</i> Attend & homework
              </span>
              <span>
                <i class="far fa-square ml-2"> A:</i> Attend, not homework
              </span>
              <span>
                <i class="far fa-square ml-2"> X:</i> Not Attended
              </span>
            </div>
          </mdb-col>
          
          <mdb-col col="12" class="px-3 py-2">
            <div class="table-responsive status-report-table">
              <table class="table table-bordered">
                <tr class="week">
                  <td colspan="2" rowspan="2" class="empty"></td>
                  <td colspan="2">WEEK</td>
                  <td v-for="index in 21" :key="index" style="width: 140px;">{{ index }}</td>
                 
                </tr>
                <tr class="lesson">
                  <td colspan="2">LESSONS IN THE BOOK</td>
                  <td v-for="index in 21" :key="index">{{ index - 1 }}</td>
                </tr>
                <tr class="header">
                  <td>#</td>
                  <td style="width: 250px;">STUDENTS NAME</td>
                  <td style="width: 200px;">PROGRAM AND LEVEL</td>
                  <td style="width: 250px;">PARENTS PHONE NUMBER</td>
                  <td v-for="index in 21" :key="index">
                    <div class="date-selection" >
                      <VueDatePicker
                        v-model="dates[index-1]"
                        format="DD/MM/YYYY"
                        placeholder="DD/MM/YYYY"
                        no-calendar-icon
                        no-header
                      />
                      <i class="fas fa-caret-down"></i>
                    </div>
                  </td>
                </tr>
                <tr v-for="(student, index) in students" :key="student._id">
                  <td>{{ index+1 }}</td>
                  <td style="width: 250px;">{{ student.name }}, {{ student.first_name }}</td>
                  <td style="width: 200px;">{{student.age_bracket}} {{ student.level }}</td>
                  <td style="width: 250px;">{{ student.guardian_phone }}</td>
                  <td v-for="index in 21" :key="index" class="status-show">
                    <div class="d-flex justify-content-space-between align-items-center" v-if="statusData[student._id][index-1]"
                    @click="selectEditStatus(student._id, index-1, statusData[student._id][index-1])">
                      <div class="status-edit" v-bind:class="{na:statusData[student._id][index-1].status=='X'}">
                        <span>
                          {{statusData[student._id][index-1].status || '@@'}}
                        </span>
                        <i class="fas fa-caret-right"></i>
                      </div>
                      <div class="comment-edit" data-toggle="tooltip" data-placement="bottom" :title="statusData[student._id][index-1].comment">
                        <i class="fas fa-pen"></i>
                        <i class="fas fa-sort-down comment-mark" v-if="statusData[student._id][index-1].comment"/>
                      </div>
                    </div>
                  </td>
                </tr>
              </table>
            </div>
            
          </mdb-col>

        </mdb-col>
      </mdb-row>

      <mdb-modal size="sm" class="videoConferencing" :show="showStatusModal" centered scrollable>
        <mdb-row class="mb-r">
          <mdb-col md="12" class="status-modal-header">
            <span class="current-date"  v-if="dates[this.selectedStatusIndex]">
              {{ dates[this.selectedStatusIndex] | moment('DD/MM/YYYY')}}
            </span>
            <span class="current-date"  v-if="!dates[this.selectedStatusIndex]">
              DD/MM/YYYY
            </span>
            <i class="fas fa-times status-modal-close" @click="showStatusModal=false"/>
          </mdb-col>
          <mdb-col md="12" class="status-modal-body">
            <div @click="selectedStatus.status='T'">
              <span>
                <i class="far fa-square ml-2" v-if="selectedStatus.status!='T'"/> 
                <i class="far fa-check-square ml-2" v-if="selectedStatus.status=='T'"/> 
                <strong class="ml-2"> T</strong>:
                Attend & homework
              </span>
            </div>
            <div @click="selectedStatus.status='A'">
              <span>
                <i class="far fa-square ml-2" v-if="selectedStatus.status!='A'"/> 
                <i class="far fa-check-square ml-2" v-if="selectedStatus.status=='A'"/> 
                <strong class="ml-2"> A</strong>:
                Attend, not homework
              </span>
            </div>
            <div @click="selectedStatus.status='X'">
              <span>
                <i class="far fa-square ml-2" v-if="selectedStatus.status!='X'"/> 
                <i class="far fa-check-square ml-2" v-if="selectedStatus.status=='X'"/> 
                <strong class="ml-2"> X</strong>:
                Not Attended
              </span>
            </div>
            <div class="mt-3">              
              <textarea placeholder="Write comment here" v-model="selectedStatus.comment">

              </textarea>
            </div>
            <button class="btn btn-success mt-3" @click="confirmUpdate();">
              CONFIRM
            </button>
          </mdb-col>
        </mdb-row>
      </mdb-modal>
</div>
</template>

<script>
import axios from "axios";
import { mdbRow, mdbCol, mdbModal} from "mdbvue";
import moment from 'moment'

export default {
    name: 'StudentStatusReport',
    components: {
        mdbRow,
        mdbCol,
        mdbModal
    },
    props: ['defaultGroup'],
    data() {
        return {
            totalGroups: "",
            searchGroup: "",
            selectedGroup: "",
            selectedStatus: "",
            selectedStatusIndex: 0,
            selectedStudentId: "",
            showStatusModal: false,
            dates: [],
            statusData: {},
            students: [],
            token : localStorage.getItem("fastAdminToken") || localStorage.getItem("fastTeacherToken"),
            // page: this.$route.params.page
        }
    },
    methods: {
      closeDialog() {
        this.$emit('closeDialog');
      },
      loadData() {
        this.selectGroup();
        this.loadStudent();
      },
      loadStudent() {
        const config = {
            headers: {
                Authorization: "Bearer " + this.token,
                'Content-Type': 'application/json'
            }
        }
        let data = {
          type: 'group',
          value: this.searchGroup
        };
        this.students =  [];
        axios.post(this.$apiURI + "/account/search-students", data, config)
          .then((response) => {
              if (response.data.error) {
                  this.$toast.open({
                      message: "Error : " + response.data.message,
                      type: 'error'
                  });
              } else {
                  for (var index in response.data.data.students) {
                    if (!response.data.data.students[index].disabled) {
                      this.students.push(response.data.data.students[index]);
                    }
                  }

                  console.log(this.students);
                  this.loadStatusData();
              }

          }).catch((error) => {
              this.$toast.open({
                  message: "Error : " + error.response.data.message,
                  type: 'error'
              });
          })
      },

      loadStatusData() {
        this.$toast.open({
            message: "Processing : Loading Data...",
            type: 'info'
        })
        const config = {
            headers: {
                Authorization: "Bearer " + this.token,
                'Content-Type': 'application/json'
            }
        }
        axios.post(this.$apiURI + "/groups-report/get", {group: this.searchGroup}, config)
        .then((response) => {
            if (response.data.error) {
              this.$toast.open({
                  message: "Error : " + response.data.message,
                  type: "error",
              });
            } else {
              if (response.data.data.report) {
                this.dates = [];
                for(var item of response.data.data.report.dates) {
                  if (item) {
                    this.dates.push(moment(item, 'DD/MM/YYYY', true).format())
                  } else {
                    this.dates.push(null)
                  }
                }
                this.statusData = {};
                var statusDD = JSON.parse(JSON.stringify(response.data.data.report.status))
                for (var ss of this.students) {
                  if (typeof(statusDD[ss._id]) !== "undefined") {
                    this.statusData[ss._id] = response.data.data.report.status[ss._id]
                  } else {
                    this.statusData[ss._id] = [];
                    for (let dd = 0; dd<21; dd++) {
                      this.statusData[ss._id].push({
                        status: '',
                        comment: ''
                      });
                    }
                  }
                }

              } else {
                this.dates = [];
                for (let dd = 0; dd<21; dd++) {
                  this.dates.push(null);
                }

                this.statusData = {};
                for (var student of this.students) {
                  this.statusData[student._id] = [];
                  for (let dd = 0; dd<21; dd++) {
                    this.statusData[student._id].push({
                      status: '',
                      comment: ''
                    });
                  }
                }
              }
            }
        })
        .catch((error) => {
            this.$toast.open({
            message: "Error : " + error.response.data.message,
            type: "error",
            });
        });
      },

      selectGroup() {
        for(var item of this.totalGroups) {
          if (item.group == this.searchGroup) {
            this.selectedGroup = item;
          }
        }
      },

      selectEditStatus (id, index, status) {
        if (this.dates[index]) {
          this.selectedStudentId = id;
          this.selectedStatusIndex = index;
          this.selectedStatus = status;
          this.showStatusModal = true;
        } else {
          this.$toast.open({
                  message: "Error : Please set date first",
                  type: 'error'
              });
        }
      },

      confirmUpdate () {
        this.showStatusModal = false;
        const updateData = {};
        updateData['dates'] = this.getDates();
        updateData['status'] = this.statusData;
        updateData['group'] = this.searchGroup;
        console.log(updateData);

        this.$toast.open({
            message: "Processing : Updating Data...",
            type: 'info'
        })
        const config = {
            headers: {
                Authorization: "Bearer " + this.token,
                'Content-Type': 'application/json'
            }
        }
        axios.post(this.$apiURI + "/groups-report/update", updateData, config)
        .then((response) => {
            if (response.data.error) {
            this.$toast.open({
                message: "Error : " + response.data.message,
                type: "error",
            });
            }
        })
        .catch((error) => {
            this.$toast.open({
            message: "Error : " + error.response.data.message,
            type: "error",
            });
        });

      },

      getDates() {
        return this.dates.map(x=>x?moment(x).format('DD/MM/YYYY'):'');
      },

      downLoadCSV() {
        let csvData = '';

        csvData += '-,-,-,week,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21\n';
        csvData += '-,-,-,lessons,0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20\n';
        csvData += '#,students name,program and level,parents phone number';
        var dateData = this.getDates();
        for (var i = 0; i < 21; i++) {
          csvData += ',' + dateData[i];
        }
        csvData += '\n';
        for (var k in this.students) {
          csvData += `${k}`;
          csvData += `,${this.students[k].first_name} ${this.students[k].last_name}`;
          csvData += `,${this.students[k].age_bracket} ${this.students[k].level}`;
          csvData += `,'${this.students[k].guardian_phone}'`;
          for (var j = 0; j < 21; j++) {
            csvData += ',' + this.statusData[this.students[k]._id][j].status;
          }
          csvData += '\n';
        }
        var blob = new Blob([csvData], { type: 'text/csv;charset=utf-8,%EF%BB%BF' });
        if (navigator.msSaveBlob) { // IE 10+
            navigator.msSaveBlob(blob, `${this.searchGroup}_report.csv`);
        } else {
            var link = document.createElement("a");
            if (link.download !== undefined) { // feature detection
                // Browsers that support HTML5 download attribute
                var url = URL.createObjectURL(blob);
                link.setAttribute("href", url);
                link.setAttribute("download", `${this.searchGroup}_report.csv`);
                link.style.visibility = 'hidden';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        }
      }
    },
    mounted() {
        this.searchGroup = this.defaultGroup;
        this.$toast.open({
            message: "Processing : Loading Data...",
            type: 'info'
        })
        const config = {
            headers: {
                Authorization: "Bearer " + this.token,
                'Content-Type': 'application/json'
            }
        }
        axios.get(this.$apiURI + "/groups", config)
        .then((response) => {
            if (response.data.error) {
            this.$toast.open({
                message: "Error : " + response.data.message,
                type: "error",
            });
            } else {
              let groups = response.data.data.groups;
              this.totalGroups = groups;
              this.selectGroup();
              this.loadStudent();  
            }
        })
        .catch((error) => {
            this.$toast.open({
            message: "Error : " + error.response.data.message,
            type: "error",
            });
        });
    }
}
</script>
